import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Trophy, ArrowRight, X } from "lucide-react";
import { useLang } from "../i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const BACKEND = process.env.REACT_APP_BACKEND_URL;

/** Bannière événement/concours — pilotée depuis le back office
 *  (activation, textes, image et programmation de publication). */
const ConcoursBanner = () => {
  const { lang } = useLang();
  const [banner, setBanner] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    axios.get(`${API}/concours/banniere`)
      .then((r) => setBanner(r.data.active ? r.data : null))
      .catch(() => {});
  }, []);

  if (!banner || dismissed) return null;

  return (
    <section data-testid="concours-banner" className="relative overflow-hidden bg-gold pt-16 lg:pt-20">
      {banner.image_url && (
        <img src={`${BACKEND}${banner.image_url}`} alt="" className="absolute inset-0 h-full w-full object-cover opacity-15" />
      )}
      <div className="relative mx-auto flex max-w-7xl flex-col items-start gap-5 px-6 py-10 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-start gap-4">
          <span className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl bg-brand-deep text-gold shadow-lg">
            <Trophy className="h-6 w-6" />
          </span>
          <div>
            <h2 data-testid="concours-banner-title" className="font-display text-xl sm:text-2xl font-extrabold text-brand-deep">{banner.titre}</h2>
            {banner.texte && <p data-testid="concours-banner-text" className="mt-1 max-w-xl text-sm font-medium text-brand-deep/75">{banner.texte}</p>}
          </div>
        </div>
        <div className="flex shrink-0 items-center gap-3">
          <Link
            to="/concours/inscription"
            data-testid="concours-banner-cta"
            className="group inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-brand-deep px-6 py-3.5 font-display font-bold text-gold shadow-lg transition-[background-color,transform] duration-300 hover:bg-brand hover:-translate-y-0.5"
          >
            {banner.bouton_label}
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
          <button
            onClick={() => setDismissed(true)}
            data-testid="concours-banner-close"
            aria-label={lang === "en" ? "Close" : "Fermer"}
            className="grid h-10 w-10 place-items-center rounded-full border border-brand-deep/20 text-brand-deep transition-colors hover:bg-brand-deep hover:text-gold"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default ConcoursBanner;
